module.exports = __webpack_public_path__ + "images/BBPS_Logodde27648e892973949c9231633abd5da.svg";